/*
 * MBB_PACKAGE_SIZE - data allowance in Oman
 * MBB_PACKAGE_SIZE_GOBIZ - data allowance at gobiz destination
 * GOBIZ_SMS_COUNT - sms at gobiz destinations
 * GOBIZ_CALLS_MIN - receive call Oman &
 * GOBIZ_UNIFIED_ROAMING - unified roaming
 * MBB_SIZE_GLOBAL - data allowance global
 */
export const planCells = [
	'MBB_PACKAGE_SIZE',
	'MBB_PACKAGE_SIZE_GOBIZ',
	'GOBIZ_SMS_COUNT',
	'GOBIZ_CALLS_MIN',
	'GOBIZ_UNIFIED_ROAMING',
	'MBB_SIZE_GLOBAL',
];

export const topUpCells = [
	'MBB_PACKAGE_SIZE',
	'MBB_PACKAGE_SIZE_GOBIZ',
	'GOBIZ_SMS_COUNT',
	'GOBIZ_CALLS_MIN',
	'MBB_SIZE_GLOBAL',
];
